import { FilterGroups, IssuersFilterOption } from '../../models';
import { COMPANY_RISK_FILTERS, FILTERS_WITHOUT_SEARCH, RANGE_FILTER_TYPES } from './Filters.constants';

export const isFilterNotSearchable = (type: IssuersFilterOption): boolean =>
  COMPANY_RISK_FILTERS.includes(type) || FILTERS_WITHOUT_SEARCH.includes(type);

type FilterTypeGroups = {
  rangeTypes: IssuersFilterOption[];
  tagTypes: IssuersFilterOption[];
};

export const splitFiltersIntoTypeGroups = (groups: FilterGroups): FilterTypeGroups => {
  const filters = Object.values(groups).flat();

  return filters.reduce<FilterTypeGroups>(
    (acc, curr) => {
      if (RANGE_FILTER_TYPES.includes(curr)) {
        return {
          ...acc,
          rangeTypes: [...acc.rangeTypes, curr],
        };
      }

      return {
        ...acc,
        tagTypes: [...acc.tagTypes, curr],
      };
    },
    {
      rangeTypes: [],
      tagTypes: [],
    }
  );
};
